import { render, staticRenderFns } from "./antenatal_patients.vue?vue&type=template&id=379154c6&"
import script from "./antenatal_patients.vue?vue&type=script&lang=js&"
export * from "./antenatal_patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports